(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cyrai-top-bar"] && !Shopify.designMode) return;
  try {
    
  const compactCyraiLanguage = () => {
    const slot = document.getElementById('cyrai-hextom-desktop');
    if (!slot) return;
    const trigger = slot.querySelector('.ht-tms-dropdown__selected') || slot.querySelector('button, [role="button"]');
    if (trigger) trigger.classList.add('cyrai-language-trigger');
    if (!slot.dataset.cyraiObserved) {
      slot.dataset.cyraiObserved = 'true';
      new MutationObserver(compactCyraiLanguage).observe(slot, {childList:true, subtree:true});
    }
  };
  const positionCyraiLanguage = () => {
    compactCyraiLanguage();
    const source = document.getElementById('cyrai-hextom-mobile-source');
    const target = document.getElementById('cyrai-hextom-mobile-target');
    if (source && target && source.children.length) {
      target.append(...source.children);
      target.hidden = false;
      document.querySelector('.cyrai-native-language')?.setAttribute('hidden', '');
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', positionCyraiLanguage, {once:true});
  else positionCyraiLanguage();
  document.addEventListener('shopify:section:load', positionCyraiLanguage);
  document.addEventListener('change', (event) => {
    if (event.target.closest('#cyrai-top-localization, #cyrai-drawer-localization')) event.target.form.requestSubmit();
  });

  } catch(e) { console.error(e); }
})();
})();
